/* global module */

// import basic css
import '@swisslife/shared-ui/src/base/reset/css/reset';
import '@swisslife/shared-ui/src/base/grid/css/grid';
import '@swisslife/shared-ui/src/base/document/css/document';
import '@swisslife/shared-ui/src/base/layout/css/layout';
import '@swisslife/shared-ui/src/base/spacing/css/spacing';
import '@swisslife/shared-ui/src/base/alignment/css/alignment';

// import from pattern lib base
import '@swisslife/patterns-base/src/atoms/logo/css/logo';
import '@swisslife/patterns-base/src/atoms/animated-svg/css/animated-svg';
import '@swisslife/patterns-base/src/atoms/loader/css/loader';
import '@swisslife/patterns-base/src/atoms/heading/css/heading';
import '@swisslife/patterns-base/src/atoms/backdrop/css/backdrop';
import '@swisslife/patterns-base/src/atoms/my-profile-link/css/my-profile-link';
import '@swisslife/patterns-base/src/molecules/step-navigation/css/step-navigation';
import '@swisslife/patterns-base/src/molecules/card/css/card';
import '@swisslife/patterns-base/src/molecules/toast/css/toast';
import '@swisslife/patterns-base/src/molecules/links-downloads/css/links-downloads';
import '@swisslife/patterns-base/src/organisms/form/css/form';
import '@swisslife/patterns-base/src/organisms/grid-form/css/grid-form';
import '@swisslife/patterns-base/src/organisms/overlay/css/overlay';

// import from pattern lib evolution
import '@swisslife/patterns-evolution/src/atoms/anchor/css/anchor';
import '@swisslife/patterns-evolution/src/molecules/image-gallery/css/image-gallery';
import '@swisslife/patterns-evolution/src/molecules/info-box/css/info-box';
import '@swisslife/patterns-evolution/src/molecules/a11y-nav/css/a11y-nav';
import '@swisslife/patterns-evolution/src/molecules/anchor-navigation/css/anchor-navigation';
import '@swisslife/patterns-evolution/src/molecules/mood-image/css/mood-image';
import '@swisslife/patterns-evolution/src/molecules/mood-image-conversion/css/mood-image-conversion';
import '@swisslife/patterns-evolution/src/molecules/quick-links/css/quick-links';
import '@swisslife/patterns-evolution/src/molecules/news-date/css/news-date';
import '@swisslife/patterns-evolution/src/molecules/news-headline/css/news-headline';
import '@swisslife/patterns-evolution/src/molecules/news-teaser/css/news-teaser';
import '@swisslife/patterns-evolution/src/molecules/page-abstract/css/page-abstract';
import '@swisslife/patterns-evolution/src/molecules/segment-teaser/css/segment-teaser';
import '@swisslife/patterns-evolution/src/molecules/share/css/share';
import '@swisslife/patterns-evolution/src/molecules/distribution-teaser/css/distribution-teaser';
import '@swisslife/patterns-evolution/src/molecules/table/css/table';
import '@swisslife/patterns-evolution/src/molecules/text-image/css/text-image';
import '@swisslife/patterns-evolution/src/molecules/favorite-link/css/favorite-link';
import '@swisslife/patterns-evolution/src/molecules/favorites-teaser/css/favorites-teaser';
import '@swisslife/patterns-evolution/src/molecules/call-to-action/css/call-to-action';
import '@swisslife/patterns-evolution/src/molecules/cookie-disclaimer/css/cookie-disclaimer';
import '@swisslife/patterns-evolution/src/molecules/elevator-pitch/css/elevator-pitch';
import '@swisslife/patterns-evolution/src/molecules/testimonial/css/testimonial';
import '@swisslife/patterns-evolution/src/molecules/listing/css/listing';
import '@swisslife/patterns-evolution/src/molecules/product-comparison/css/product-comparison';
import '@swisslife/patterns-evolution/src/molecules/product-comparison-image/css/product-comparison-image';
import '@swisslife/patterns-evolution/src/molecules/teaser/css/teaser';
import '@swisslife/patterns-evolution/src/molecules/marketing-teaser/css/marketing-teaser';
import '@swisslife/patterns-evolution/src/molecules/teaser-text/css/teaser-text';
import '@swisslife/patterns-evolution/src/molecules/teaser-row/css/teaser-row';
import '@swisslife/patterns-evolution/src/molecules/purpose-hub-teaser/css/purpose-hub-teaser';
import '@swisslife/patterns-evolution/src/molecules/product-overview-teaser/css/product-overview-teaser';
import '@swisslife/patterns-evolution/src/molecules/iframe/css/iframe';
import '@swisslife/patterns-evolution/src/molecules/video-teaser/css/video-teaser';
import '@swisslife/patterns-evolution/src/molecules/breadcrumb/css/breadcrumb';
import '@swisslife/patterns-evolution/src/molecules/language-navigation/css/language-navigation';
import '@swisslife/patterns-evolution/src/molecules/appointment-scheduler/css/appointment-scheduler';
import '@swisslife/patterns-evolution/src/molecules/content-image/css/content-image';
import '@swisslife/patterns-evolution/src/molecules/contact-info/css/contact-info';
import '@swisslife/patterns-evolution/src/molecules/collapse-stepper/css/collapse-stepper';
import '@swisslife/patterns-evolution/src/molecules/tooltip/css/tooltip';
import '@swisslife/patterns-evolution/src/molecules/form-wrap-elements/css/form-wrap-elements';
import '@swisslife/patterns-evolution/src/molecules/image-slider/css/image-slider';
import '@swisslife/patterns-evolution/src/molecules/immo-teaser/css/immo-teaser';
import '@swisslife/patterns-evolution/src/organisms/header/css/header';
import '@swisslife/patterns-evolution/src/organisms/footer/css/footer';
import '@swisslife/patterns-evolution/src/organisms/accordion/css/accordion';
import '@swisslife/patterns-evolution/src/organisms/fusion-widget/css/fusion-widget';
import '@swisslife/patterns-evolution/src/organisms/grid-row/css/grid-row';
import '@swisslife/patterns-evolution/src/organisms/overview-teaser/css/overview-teaser';
import '@swisslife/patterns-evolution/src/organisms/news-archive/css/news-archive';
import '@swisslife/patterns-evolution/src/organisms/purpose-hub/css/purpose-hub';
import '@swisslife/patterns-evolution/src/organisms/video-hub/css/video-hub';
import '@swisslife/patterns-evolution/src/organisms/page/css/page';
import '@swisslife/patterns-evolution/src/organisms/filter/css/filter';
import '@swisslife/patterns-evolution/src/organisms/search-result/css/search-result';
import '@swisslife/patterns-evolution/src/organisms/template/css/template';
import '@swisslife/patterns-evolution/src/organisms/quiz/css/quiz';
import '@swisslife/patterns-evolution/src/organisms/onetrust-wrapper/css/onetrust-wrapper';
